if (document.getElementById('ee-tracking-page')) {

    // --- helpery bezpieczeństwa ---

    // Escapuje wartości wstawiane do innerHTML (ochrona przed XSS).
    function esc(s) {
        return String(s ?? '').replace(/[&<>"']/g, c => ({
            '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        }[c]));
    }

    // Dopuszcza tylko http(s) w linku trackingu (blokuje np. javascript:).
    function safeUrl(u) {
        try {
            const p = new URL(u);
            return (p.protocol === 'https:' || p.protocol === 'http:') ? p.href : '#';
        } catch {
            return '#';
        }
    }

    document
        .getElementById('orderTrackingForm')
        .addEventListener('submit', async function (e) {

            e.preventDefault();

            const orderNumber =
                document.getElementById('orderNumber').value.trim();

            const email =
                document.getElementById('orderEmail').value.trim();

            const resultBox =
                document.getElementById('tracking-result');

            resultBox.style.display = 'block';

            resultBox.innerHTML = `
                <div class="ee-result">
                    <div class="ee-result-title">
                        Tražimo vašu pošiljku...
                    </div>
                </div>
            `;

            // Blokada przycisku na czas zapytania (brak podwójnych kliknięć)
            const submitBtn = e.currentTarget.querySelector('button[type="submit"]');
            const originalBtnText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Pretraživanje…';
            }

            try {

                const response = await fetch(
                        'https://euroelectronics-tracker.patryk-sprus.workers.dev/track',
                    {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            orderNumber,
                            email,
                            store: "HR"
                        })
                    }
                );

const data = await response.json();

// Za dużo prób (rate limit) — osobny komunikat
if (response.status === 429 || data.status === 'RATE_LIMITED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Previše pokušaja
            </div>

            <div class="ee-error-message">
                Obavili ste previše pretraživanja zaredom.
                Pričekajte minutu i pokušajte ponovno.
            </div>

        </div>
    `;

    return;
}

if (data.status === 'CANCELLED') {

    resultBox.innerHTML = `
        <div class="ee-result ee-result-error">

            <div class="ee-result-title">
                Narudžba je otkazana
            </div>

            <div class="ee-error-message">
                Ova narudžba je otkazana i neće biti obrađena.
            </div>

        </div>
    `;

    return;
}

if (!data.success) {

if (data.status === 'NOT_SHIPPED') {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-pending">

                <div class="ee-result-title">
                    Pripremamo vašu narudžbu
                </div>

<div class="ee-info-message">


 <br>

    Vaša narudžba je zaprimljena i obrađuje se.

    <br><br>

    Broj za praćenje još nije dodijeljen.
    Nakon što pošiljka bude poslana, informacije o praćenju bit će dostupne na ovoj stranici i putem e-pošte.

    <br><br>

    Ako imate dodatnih pitanja o svojoj narudžbi, obratite se našoj službi za korisnike.

    <br>

                    <a href="https://euroelectronics.hr/pages/contact-1" class="ee-contact-link">
                        Kontaktirajte nas
                    </a>

                </div>

            </div>
        `;

    } else {

        resultBox.innerHTML = `
            <div class="ee-result ee-result-error">

                <div class="ee-result-title">
                    Narudžba nije pronađena
                </div>

                <div class="ee-error-message">
                    Nismo mogli pronaći narudžbu koja odgovara navedenom broju narudžbe i adresi e-pošte.

                    Provjerite jesu li podaci ispravno uneseni i pokušajte ponovno.
                    <br><br>

                    Ako trebate pomoć, obratite se našoj službi za korisnike.
                    <br>

                    <a href="https://euroelectronics.hr/pages/contact-1" class="ee-contact-link">
                        Idi na obrazac za kontakt
                    </a>

                </div>

            </div>
        `;

    }

    return;
}
const productsHtml =
  (data.products || [])
    .map(product => `
 <div class="ee-product">

    <div class="ee-product-content">

        <div class="ee-product-title">
            ${esc(product.title)}
        </div>

    </div>

    <div class="ee-product-qty">
        ${esc(product.quantity)}x
    </div>

</div>
    `)
    .join('');

                resultBox.innerHTML = `
                    <div class="ee-result">

                        <div class="ee-result-title">
                            Pošiljka je pronađena
                        </div>
<div class="ee-result-description">
                            U nastavku se nalaze informacije o vašoj pošiljci.
                          
                            Kliknite gumb u nastavku kako biste izravno pristupili praćenju kod prijevoznika.
                           
                       </div>

                       

                        <div class="ee-result-grid">

                            <div>
                                <div class="ee-result-label">
                                    Broj narudžbe
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.orderNumber || orderNumber)}
                                </div>
                            </div>

                            <div>
                                <div class="ee-result-label">
                                    Broj za praćenje
                                </div>

                                <div class="ee-result-value">
                                    ${esc(data.trackingNumber)}
                                </div>
                            </div>

                        </div>

                        <a
                            href="${safeUrl(data.trackingUrl)}"
                            target="_blank"
                            rel="noopener"
                            class="ee-track-btn"
                        >
                            Prati pošiljku
                        </a>

                    </div>

                    <div class="ee-products-section">

  <div class="ee-products-title">
       Naručeni proizvodi (${data.products?.length || 0})
  </div>

  ${productsHtml}

</div>
                `;

                resultBox.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest'
                });

            } catch (err) {

                console.error(err);

                resultBox.innerHTML = `
                    <div class="ee-result ee-result-error">

                        <div class="ee-result-title">
                            Došlo je do pogreške
                        </div>

                        <p>
                            Nije se moguće povezati sa sustavom za praćenje.
                            Pokušajte ponovno za nekoliko trenutaka.
                        </p>

                    </div>
                `;

            } finally {

                // Odblokowanie przycisku niezależnie od wyniku
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.textContent = originalBtnText;
                }

            }

        });

}